import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Fade,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import BitSmart from "src/assets/bitmart.svg";
import DogLeg from "src/assets/dog-leg.png";
import BuyImg from "src/assets/logo-token.png";
import LogoSvg from "src/assets/logo.png";
import MetaMaskLogo from "src/assets/metamask.png";
import PanImg from "src/assets/pan.png";
import Iconify from "src/components/Iconify";
import { USE_BASE_URL } from "src/config";
import useSetup from "src/cryptoUtilities/useSetup";
import { describeWalletError } from "src/cryptoUtilities/wallet-error";
import "src/pages/style.scss";
import { useMetaMask } from "src/store/metamask";
import Web3 from "web3";
import Drawer from "./drawer";

const Layout = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openConnect, setOpenConnect] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (pathname === "/") {
      navigate("/key");
    }
  }, [pathname]);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenConnect(false);
  };
  const [storeData] = useMetaMask();

  const setup = useSetup();
  const onConnected = async () => {
    const data = await setup();
    if (data) {
      setOpenConnect(false);
    } else {
      setOpenConnect(true);
    }
  };

  useEffect(() => {
    async function checkForMetaMask() {
      // Modern dapp browsers...
      if (window.ethereum) {
        try {
          // Request account access if needed
          await window.ethereum.request({ method: "eth_requestAccounts" });
          console.log("MetaMask is installed and enabled.");
          // Further code to interact with MetaMask using Web3.js
        } catch (error) {
          // Not necessarily a denial: this runs on mount, so it collides with
          // the same request from drawer.jsx and from the Connect button.
          const { code, raw } = describeWalletError(error);
          console.warn(`[wallet-connect] mount-time eth_requestAccounts failed (${code}): ${raw}`);
        }
      }
      // Legacy dapp browsers...
      else if (window.web3) {
        // Use Mist/MetaMask's provider
        const web3 = new Web3(window.web3.currentProvider);
        console.log("MetaMask is installed and enabled.");
        // Further code to interact with MetaMask using Web3.js
      }
      // Non-dapp browsers...
      else {
        console.log("MetaMask is not installed or not enabled.");
        // Show an error message or instructions to install MetaMask
      }
    }

    checkForMetaMask();
  }, []);

  return (
    <>
      <header
        className="header"
        id="header"
        style={{ backgroundColor: "#212429" }}
      >
        <nav className="navbar container">
          <a href={USE_BASE_URL} className="brand">
            <img src={LogoSvg} width={30} style={{ objectFit: "contain" }} />

            <span
              className="mobile-size-para"
              style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}
            >
              BTAF token
            </span>
          </a>
          <a href="https://btaftoken.io/faqs/" >
            <img
              src={DogLeg}
              style={{
                width: "30px",
                height: "fit-content",
                objectFit: "contain",
              }}
            />
          </a>
          <div className="burger">
            <Drawer />
          </div>
          <div className="menu" id="menu">
            <ul className="menu-inner">
              {/* <li className="menu-item">
                <Link to="/key" className="menu-link">
                  BTAFKey
                </Link>
              </li> */}
              {/* <li className="menu-item">
                <a
                  href={`${USE_BASE_URL}our-team`}
                  className="menu-link"
                >
                  BTAF Team
                </a>
              </li> */}
              <li className="menu-item">
                <span className="badge-new">New</span>
                <Link to="https://opensea.io/BTAFTokenNFT" className="menu-link" target="_blank"
    rel="noopener noreferrer">
                  NFTs
                </Link>
              </li>
              <li className="menu-item dropdown-container">
                <span className="menu-link" style={{ cursor: "default", display: "flex", alignItems: "center" }}>
                  About Us <Iconify icon="mdi:chevron-down" style={{ marginLeft: "4px", fontSize: "14px" }} />
                </span>
                <div className="dropdown-menu">
                  <a href="https://btaftoken.io/blogs/" target="_blank" className="dropdown-item" rel="noreferrer">Blogs</a>
                  <a href="https://btaftoken.io/our-team/" target="_blank" className="dropdown-item" rel="noreferrer">Our Team</a>
                  <Link to="/pay" className="dropdown-item">BTAFPay</Link>
                </div>
              </li>
              <li className="menu-item">
                <span className="badge-new">New</span>
                <Link to="/stake" className="menu-link">
                  Stake
                </Link>
              </li>
              <li className="menu-item">
                <Link to="https://btaftoken.io/buy/" className="menu-link" target="_blank"
    rel="noopener noreferrer">
                  Buy
                </Link>
                {/* <Link to="/pay" className="menu-link">
                  BTAFPay
                </Link> */}
              </li>
              <li className="menu-item">
                <Link
                  to="https://bitcointaf.com/whisper-drop/"
                  className="menu-link" target="_blank"
    rel="noopener noreferrer"
                >
                  Whisper Drop
                </Link>
                {/* <Link
                  to="https://blog.btaftoken.io/"
                  className="menu-link"
                >
                  BTAF Blog
                </Link> */}
              </li>
            </ul>
          </div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              columnGap: "1.25rem",
            }}
            className="mobile-dsplay-none"
          >
            {/* <Button
              onClick={() => {
                if (!storeData.signerAddress) {
                  onConnected();
                }
              }}
              variant="contained"
              sx={{ borderRadius: "1rem", marginLeft: 2, fontWeight: 600 }}
              size="small"
              className="connect-btn mobile-btn-layout"
            >
              {storeData.signerAddress ? "Connected" : "Connect"}
            </Button> */}

            <Button
              sx={{
                borderRadius: "1rem",
                marginLeft: 2,
                fontWeight: 600,
                color: "#fff",
              }}
              size="small"
              className="buy-taf-btn mobile-btn-layout"
              id="fade-button"
              aria-controls={open ? "fade-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              Buy $BTAF
            </Button>
            <Menu
              id="fade-menu"
              MenuListProps={{
                "aria-labelledby": "fade-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              TransitionComponent={Fade}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "#222429",
                  borderRadius: "0.5rem",
                  marginTop: "2%",
                },
              }}
            >
              <MenuItem onClick={handleClose}>
                <a
                  href="https://www.bitmart.com/trade/en-US?symbol=BTAF_USDT"
                  target="_blank"
                  style={{ color: "#fff", fontWeight: 700 }}
                >
                  <Box display="flex">
                    <img
                      src={BitSmart}
                      width="24px"
                      style={{ marginRight: "10px" }}
                    />
                    BitMart
                  </Box>
                </a>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <a
                  href="https://pancakeswap.finance/swap?outputCurrency=0xcAE3d82D63e2b0094bc959752993D3D3743B5D08"
                  target="_blank"
                  style={{ color: "#fff", fontWeight: 700 }}
                >
                  <Box display="flex">
                    <img src={PanImg} style={{ marginRight: "10px" }} />
                    PancakeSwap
                  </Box>
                </a>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <a
                  href="https://bitcointaf.com/product/BUYBTAF/"
                  target="_blank"
                  style={{ color: "#fff", fontWeight: 700 }}
                >
                  <Box display="flex">
                    <img src={BuyImg} style={{ marginRight: "10px" }} />
                    Buy Direct
                  </Box>
                </a>
              </MenuItem>

              {/* <MenuItem onClick={handleClose}>
                <a
                  href="https://www.dextools.io/app/en/bnb/pair-explorer/0x7ac443da58259a664e9bb7f4c85ed913d222a8ee"
                  target="_blank"
                  style={{ color: "#fff", fontWeight: 700 }}
                >
                  <Box display="flex">
                    <img src={DexImg} style={{ marginRight: "10px" }} />
                    DexTools
                  </Box>
                </a>
              </MenuItem> */}
            </Menu>
          </Box>
        </nav>
      </header>

      {/* dialog  */}

      <Dialog
        open={openConnect}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#212429",
            borderRadius: "2rem",
          },
        }}
      >
        <DialogTitle id="responsive-dialog-title" sx={{ color: "#fff", mt: 5 }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Iconify icon="ic:outline-close" />
          </IconButton>
          <Typography variant="h5" sx={{ fontWeight: 800 }}>
            Connect Wallet
          </Typography>
        </DialogTitle>

        {/* Connect Wallet  */}
        <DialogContent>
          <Button
            variant="outlined"
            onClick={onConnected}
            sx={{
              borderRadius: "3rem",
              textTransform: "capitalize",
              mt: 1,
              fontWeight: 600,
              color: "#fff",
            }}
            fullWidth
            size="large"
            startIcon={
              <img src={MetaMaskLogo} style={{ margin: "0px 20px 0px 0px" }} />
            }
          >
            Meta Mask
          </Button>
          <Typography
            variant="subtitle2"
            fontWeight={500}
            style={{ color: "#ccc" }}
            mt={2}
            mb={2}
          >
            You don't have any crypto wallet?
          </Typography>
          <Button
            variant="contained"
            sx={{
              borderRadius: "1rem",
              textTransform: "capitalize",
              mt: 1,
              fontWeight: 600,
            }}
            className="connect-btn"
            fullWidth
            size="large"
            href="https://academy.binance.com/en/articles/connecting-metamask-to-binance-smart-chain"
            target="_blank"
          >
            Learn how to connect
          </Button>
        </DialogContent>
      </Dialog>
      {children}
      <Outlet />
    </>
  );
};

export default Layout;
